import Validator from 'validatorjs';
import en from 'validatorjs/src/lang/en';

// validatorjs (src/lang.js) loads its language files via a dynamic CommonJS
// `require('./lang/' + lang)`, which Vite cannot resolve at bundle time. As a
// result `Lang._make('en')` returns a Messages instance whose `messages` is
// undefined, and rendering any validation error throws on `messages.def`.
// Register the built-in English messages up front to avoid the crash.
Validator.setMessages('en', en);
